export function compareBoxes_X(a, b) {
  return a.left - b.left;
}
